
import React, { Component } from 'react';
import SlidePanel from '../shared/SlidePanel';
import { connect } from 'react-redux';
import { Modal, Dropdown } from 'react-bootstrap';
import { openOnboardingLayer } from '../onboarding/ImportJobContext';
import { ONBOARDING_ENABLED } from '../onboarding/flags';
import DatePicker from "react-datepicker";

import TopHeader from '../template/TopHeader';
import StaffTopNav from './StaffTopNav';
import PermissionsPage from '../permissions/PermissionsPage';
import { SharingTabs } from '../settings/SharingPage';
import { can, canImport } from '../permissions/access';
import { PERMISSIONS_VISIBLE } from '../../config/featureFlags';
import StaffPay from './staff-pay/StaffPay';
import { Link } from 'react-router-dom';
import {hairdresserActions, paymentActions} from "../../_actions";
import { Plus, MySpinner } from '../SvgIcon';
import { RxCross2 } from "react-icons/rx";
import moment from "moment";
import {hairdresserService} from "../../_services";
import Lottie from 'react-lottie';
import animationData from '../../assets/animation-data/loader.json';
import siteSetting from "../../config/env";
import EditStaff from './EditStaff';
import ListContextMenu from '../shared/ListContextMenu';
import AddStaff from './AddStaff';
import ShiftTimePicker from '../Diary/ShiftTimePicker';
import './seChoices/TheirChoices.css';
import { sitesService, siteColour } from '../../_services/sites.service';
import './Staff.css';

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};

var _ = require('lodash');

const isWeekday = date => {
    const day = date.getDay(date);
    return day !== 0 && day !== 2 && day !== 3 && day !== 4 && day !== 5 && day !== 6;
};

function TimePicker({ value, onChange }) {
    const date = value ? new Date(value) : null;
    const hr = date ? date.getHours() : '';
    const min = date ? date.getMinutes() : '';

    const handleHour = (e) => {
        const h = parseInt(e.target.value);
        const m = min || 0;
        const d = new Date();
        d.setHours(h, m, 0, 0);
        onChange(d);
    };

    const handleMinute = (e) => {
        const m = parseInt(e.target.value);
        const h = hr || 0;
        const d = new Date();
        d.setHours(h, m, 0, 0);
        onChange(d);
    };

    const hours = Array.from({ length: 24 }, (_, i) => i);
    const minutes = Array.from({ length: 12 }, (_, i) => i * 5);

    return (
        <div className="eh-time-selects">
            <select className="eh-time-select" value={hr !== '' ? hr : ''} onChange={handleHour}>
                <option value="" disabled>HH</option>
                {hours.map(h => (
                    <option key={h} value={h}>{String(h).padStart(2, '0')}</option>
                ))}
            </select>
            <span className="eh-time-colon">:</span>
            <select className="eh-time-select" value={min !== '' ? min : ''} onChange={handleMinute}>
                <option value="" disabled>MM</option>
                {minutes.map(m => (
                    <option key={m} value={m}>{String(m).padStart(2, '0')}</option>
                ))}
            </select>
        </div>
    );
}

function AddBreak(props) {
    return (
        <div className="eh-break">
            <div className="eh-break-header">
                <span className="eh-break-label">Break</span>
                <button className="eh-break-remove" onClick={props.removeBreak.bind(this, props.i)} type="button">Remove</button>
            </div>
            <div className="eh-time-row">
                <div className="eh-time-field">
                    <label>Start</label>
                    <ShiftTimePicker label="Break Start" selected={props.startTime} onChange={(val) => props.selectSlot('breakStartTime_' + props.i, val)} />
                </div>
                <div className="eh-time-field">
                    <label>Finish</label>
                    <ShiftTimePicker label="Break Finish" selected={props.endTime} onChange={(val) => props.selectSlot('breakEndTime_' + props.i, val)} />
                </div>
            </div>
        </div>
    );
}

class Staff extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editHoursModal: false,
            datePickerModal: false,
            selectedDay: '',
            days: '',
            selectedHairdresser: {},
            breakTime: [],
            startTime: '',
            endTime: '',
            selectedStartDate: '',
            rotaTimeError: '',
            rotaDateError: '',
            successTimeMessage: '',
            successDateMessage: '',
            addStaffModal: false,
            activationCode: "",
            employmentTypeId: "1",
            selfEmpCount: 0,
            activatationCodeError: "",
            error: "",
            activatationCodeSuccess: "",
            discount: 0,
            totalPayment: siteSetting.stripe.salonMonthlyPrice + siteSetting.stripe.oneSelfEmpPrice,
            totalPaymentBefore: siteSetting.stripe.salonMonthlyPrice + siteSetting.stripe.oneSelfEmpPrice,
            isApplyedPromocode: false,
            applyCoupon: false,
            planPrice: siteSetting.stripe.salonMonthlyPrice,
            planType: "month",
            subscriptionInfo: {},
            oneSelfEmpPrice: siteSetting.stripe.oneSelfEmpPrice,
            oneSelfEmpPriceBefore: siteSetting.stripe.oneSelfEmpPrice,
            quantity: 0,
            isRotaLoading: false,
            isRotaDeleteLoading: false,
            ehClosing: false,
            searchQuery: '',
            scheduleSearch: '',
            filterBy: 'All',
            // Self Employed filter only: the people list, or Their choices.
            showFilterDropdown: false,
            viewMode: 'card',
            activeTab: 'staffMember',
            openMenuId: null,
            editStaffId: null,
            editStaffAction: null,
            showAddStaff: false,
            contextMenu: null,
        };

        this.onDataChange = this.onDataChange.bind(this);
        this.getslotTime = this.getslotTime.bind(this);
        this.addBreak = this.addBreak.bind(this);
        this.selectSlot = this.selectSlot.bind(this);
        this.saveRota = this.saveRota.bind(this);
        this.saveStartDateRota = this.saveStartDateRota.bind(this);
        this.deleteRota = this.deleteRota.bind(this);
        this.selectStartDate = this.selectStartDate.bind(this);
        this.removeBreak = this.removeBreak.bind(this);
        this.selectStaff = this.selectStaff.bind(this);
    }

    componentDidMount() {
        var self = this;
        if (localStorage.getItem('accessToken')) {
            let hairdresserId = localStorage.getItem('userId');
            let params = {
                searchKey: this.state.searchKey,
                'hairdresserId': hairdresserId,
                page: 1,
                listType: 1,
                isGetRota: 1
            };
            self.props.dispatch(hairdresserActions.hairdresserStaffWithoutService(params));
            self.props.dispatch(hairdresserActions.hairdresserStaffRota(params));
            
            // Set activeTab based on URL path
            const path = this.props.location?.pathname || window.location.pathname;
            // Resolve the active tab from the URL, then fall back to the first
            // visible Team tab if reception mode has hidden the requested one.
            const isOwner = this.props.user?.userInfo?.hairdresser?.isSalonOwner === 1;
            let reception = {};
            try { reception = JSON.parse(localStorage.getItem('receptionModeSettings') || '{}'); } catch (e) { /* ignore */ }
            const tabHidden = (key) => isOwner && reception.enabled && reception.hiddenAreas && reception.hiddenAreas[key];
            const tabKey = { staffMember: 'teamMembers', schedules: 'schedules', staffPay: 'staffPay' };

            let intendedTab;
            if (path === '/staff/schedules' || path === '/staff/rota') intendedTab = 'schedules';
            else if (path === '/staff/staff-pay') intendedTab = 'staffPay';
            else if (path === '/staff/permissions') intendedTab = 'permissions';
            else if (path === '/staff/sharing') intendedTab = 'sharing';
            else intendedTab = 'staffMember';

            if (tabHidden(tabKey[intendedTab])) {
                intendedTab = ['staffMember', 'schedules', 'staffPay'].find(t => !tabHidden(tabKey[t])) || 'staffMember';
            }
            // Roles & permissions: a tab you can't use lands on Team Members.
            if (!this.teamTabs()[intendedTab]) intendedTab = 'staffMember';
            this.setState({ activeTab: intendedTab });
            
            // Add click listener to close dropdown menus when clicking outside
            document.addEventListener('click', this.handleClickOutside, true);
        } else {
            this.props.history.push('/');
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    }

    handleClickOutside = (e) => {
        // Close menu if clicking outside of it
        // Don't close if clicking on the menu button itself (let toggleStaffMenu handle that)
        if (this.state.openMenuId) {
            const isMenuButton = e.target.closest('.staff-more-btn');
            const isDropdownMenu = e.target.closest('.staff-dropdown-menu');
            
            if (!isMenuButton && !isDropdownMenu) {
                this.setState({ openMenuId: null });
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        let self = this;
        if (this.props?.staffRota?.rota !== prevProps?.staffRota?.rota) {
            if (this.props?.staffRota?.rota?.length > 0) {
                let selfEmp = this.props.staffRota.rota.filter(staff => staff?.hairdresserInfo?.isSalonOwner == 0 && staff?.hairdresserInfo?.employmentTypeId == 2);
                self.setState({
                    selfEmpCount: selfEmp.length,
                });
            }
        }
    }

    // Fill the sheet's start/finish/breaks from a rotaInfo ({ rota: { schedule } }) for one day key.
    hydrateHoursFrom = (rotaInfo, days) => {
        let self = this;
        if (rotaInfo?.rota?.schedule) {
            let rotaTime = _.find(rotaInfo?.rota?.schedule[0]?.profiles, function (obj) {
                return obj.day === days;
            });
            if (rotaTime) {
                let breakTime = [];
                _.map(rotaTime.breakTimes, function (obj, i) {
                    if (obj.startTime !== '' && obj.endTime !== '') {
                        breakTime.push({ id: i + 1 });
                        let hrBSt = parseInt(obj.startTime / 60);
                        let minBSt = obj.startTime - (hrBSt * 60);
                        let hrBEt = parseInt(obj.endTime / 60);
                        let minBEt = obj.endTime - (hrBEt * 60);
                        self.setState({
                            ['breakStartTime_' + (i + 1)]: new Date().setHours(hrBSt, minBSt),
                            ['breakEndTime_' + (i + 1)]: new Date().setHours(hrBEt, minBEt),
                        });
                    }
                });
                let hrSt = parseInt(rotaTime.startTime / 60);
                let minSt = rotaTime.startTime - (hrSt * 60);
                let hrEt = parseInt(rotaTime.endTime / 60);
                let minEt = rotaTime.endTime - (hrEt * 60);
                this.setState({
                    startTime: new Date().setHours(hrSt, minSt),
                    endTime: new Date().setHours(hrEt, minEt),
                    breakTime
                });
                return;
            }
        }
        this.setState({ startTime: "", endTime: "", breakTime: [] });
    }

    // Multi-location: which rota the sheet is editing — the active site's (from the
    // staff list) or a sister site's fetched via /sites/staff/rota.
    crossSiteHours = () => !!(this.state.hoursSalonId && this.state.hoursSalonId !== localStorage.getItem('salonId'));
    currentHoursRotaInfo = () => (this.crossSiteHours() ? this.state.hoursSiteRota : (this.state.selectedHairdresser && this.state.selectedHairdresser.rotaInfo)) || {};
    selectHoursSite = (salonId) => {
        const self = this;
        const userId = this.state.selectedHairdresser && this.state.selectedHairdresser._id;
        this.setState({ hoursSalonId: salonId, rotaTimeError: '', successTimeMessage: '' });
        if (salonId === localStorage.getItem('salonId')) {
            this.setState({ hoursSiteRota: null });
            this.hydrateHoursFrom(this.state.selectedHairdresser && this.state.selectedHairdresser.rotaInfo, this.state.days);
            return Promise.resolve();
        }
        this.setState({ hoursSiteLoading: true });
        return sitesService.staffRota(userId, salonId).then((r) => {
            self.setState({ hoursSiteRota: (r && r.rotaInfo) || {}, hoursSiteLoading: false });
            self.hydrateHoursFrom(r && r.rotaInfo, self.state.days);
        }).catch((e) => {
            self.setState({ hoursSiteLoading: false, rotaTimeError: e.message || 'Could not load hours at that location' });
        });
    }

    handleEditHoursModal = (fullday, hairdresser, days) => {
        let self = this;
        const opening = !this.state.editHoursModal;
        // Always start on the device's active site; sister-site tabs load on demand.
        this.setState({ hoursSalonId: localStorage.getItem('salonId'), hoursSiteRota: null, hoursSites: null });
        if (opening && hairdresser && hairdresser._id) {
            sitesService.staffSites(hairdresser._id).then((info) => {
                const works = (info && info.worksAt) || [];
                if (works.length > 1) self.setState({ hoursSites: works });
            }).catch(() => { /* single-site account or no access: no tabs */ });
        }
        this.hydrateHoursFrom(hairdresser && hairdresser.rotaInfo, days);

        this.setState({
            rotaTimeError: '',
            rotaDateError: '',
            successTimeMessage: '',
            successDateMessage: '',
            days: days,
            selectedDay: fullday,
            selectedHairdresser: hairdresser,
            editHoursModal: !this.state.editHoursModal,
            ehClosing: false
        });
    }

    closeEditHours = () => {
        this.setState({ editHoursModal: false });
    }

    handleDatePickerModal = (hairdresser) => {
        this.setState({
            selectedStartDate: hairdresser && hairdresser.rotaInfo.rota && hairdresser.rotaInfo.rota.startDate ? new Date(moment(hairdresser.rotaInfo.rota.startDate, 'YYYY-MM-DD')) : new Date(moment().startOf('isoweek'))
        });

        this.setState({
            rotaTimeError: '',
            rotaDateError: '',
            successTimeMessage: '',
            successDateMessage: '',
            selectedHairdresser: hairdresser,
            datePickerModal: !this.state.datePickerModal
        });
    }

    getslotTime(time) {
        let hr = parseInt(time / 60);
        let min = time - (hr * 60);
        return String(hr).padStart(2, '0') + ':' + String(min).padStart(2, '0');
    }

    getTime = (rotaInfo, days) => {
        if (rotaInfo && rotaInfo.rota && rotaInfo.rota.schedule) {
            let rotaTime = _.find(rotaInfo.rota.schedule[0].profiles, function (obj) {
                return obj.day === days;
            });
            if (rotaTime) {
                return (
                    <span className="schedule-pill">
                        <span className="schedule-time">{this.getslotTime(rotaTime.startTime)}</span>
                        <span className="schedule-pill-sep"> - </span>
                        <span className="schedule-time">{this.getslotTime(rotaTime.endTime)}</span>
                    </span>
                );
            } else {
                return <span className="schedule-off">&ndash;</span>;
            }
        } else {
            return <span className="schedule-off">&ndash;</span>;
        }
    }

    getRotaStartDate = (rotaInfo) => {
        if (rotaInfo && rotaInfo.rota && rotaInfo.rota.schedule) {
            return moment(rotaInfo.rota.startDate).format('ddd, DD MMM YYYY');
        } else {
            return '--';
        }
    }

    onDataChange(value, action) {
        this.setState({
            [action.name]: value,
            [action.name + "Id"]: value.value
        });
    }

    addBreak() {
        let breakTime = this.state.breakTime;
        let count = breakTime.length;
        breakTime.push({ id: count + 1 });
        this.setState({ breakTime });
    }

    removeBreak(remove) {
        let breakTime = this.state.breakTime;
        _.remove(breakTime, item => item.id === remove);
        this.setState({ breakTime: breakTime });
    }

    selectSlot(type, e) {
        this.setState({
            [type]: e
        });
    }

    getMinTime(time) {
        let sTime = moment(time).format('HH:mm');
        let sTimeArr = sTime.split(":");
        let min = (parseInt(sTimeArr[0]) * 60) + parseInt(sTimeArr[1]);
        return min;
    }

    openAddStaffmodal = () => {
        this.setState({
            addStaffModal: true
        });
    }

    handleClose = () => {
        this.setState({
            addStaffModal: false,
            activationCode: "",
            applyCoupon: false,
            activatationCodeError: "",
            error: "",
            activatationCodeSuccess: "",
            discount: 0,
            employmentTypeId: "1",
        });
    }

    showActivationCode = () => {
        this.setState({
            applyCoupon: !this.state.applyCoupon,
        });
    }

    hideActivationCode = () => {
        this.setState({
            applyCoupon: false,
            activatationCodeError: "",
            error: "",
            activatationCodeSuccess: "",
            activationCode: "",
            totalPayment: siteSetting.stripe.salonMonthlyPrice + siteSetting.stripe.oneSelfEmpPrice,
            totalPaymentBefore: siteSetting.stripe.salonMonthlyPrice + siteSetting.stripe.oneSelfEmpPrice,
        });
    }

    saveRota() {
        let self = this;
        let hairdresser = this.state.selectedHairdresser;
        const rotaInfo = self.currentHoursRotaInfo();   // active site's rota, or the selected sister site's
        let profiles = [];
        if (rotaInfo.rota && rotaInfo.rota.schedule) {
            _.map(rotaInfo.rota.schedule[0].profiles, function (obj) {
                if (obj.day !== self.state.days) {
                    profiles.push({
                        "day": obj.day,
                        "startTime": obj.startTime,
                        "endTime": obj.endTime,
                        "breakTimes": obj.breakTimes
                    });
                }
            });
        }
        let breakTimes = [];
        _.map(self.state.breakTime, function (obj) {
            if (self.state['breakStartTime_' + obj.id] !== '' && self.state['breakEndTime_' + obj.id] !== '') {
                breakTimes.push({
                    "startTime": self.getMinTime(self.state['breakStartTime_' + obj.id]),
                    "endTime": self.getMinTime(self.state['breakEndTime_' + obj.id]),
                });
            }
        });
        profiles.push({
            "day": self.state.days,
            "startTime": self.getMinTime(self.state.startTime),
            "endTime": self.getMinTime(self.state.endTime),
            "breakTimes": breakTimes
        });
        let params = {};
        params.rotaStartDate = rotaInfo.startDate ? rotaInfo.startDate : moment().startOf('isoweek').format("YYYY-MM-DD");
        params.rota = [];

        let obj = {
            "weekNumber": 1,
            profiles: profiles
        };
        params.rota.push(obj);
        params.hairdresserId = hairdresser._id;
        self.setState({
            isRotaLoading: true
        });
        // A sister site's hours go through the explicit cross-site plane; the active site keeps the legacy call.
        const saveCall = self.crossSiteHours()
            ? sitesService.saveStaffRota({ ...params, userId: hairdresser._id, salonId: self.state.hoursSalonId })
                .then(() => ({ data: { errorCode: 0 } }), (e) => ({ data: { errorCode: 1, messages: e.message || 'Could not save hours' } }))
            : hairdresserService.saveRota(params);
        saveCall
            .then(function (response) {
                if (response.data.errorCode === 0) {
                    self.props.dispatch(hairdresserActions.hairdresserStaffRota({ isGetRota: 1, 'hairdresserId': localStorage.getItem('userId') })).then(res => {
                        self.setState({
                            successTimeMessage: 'Rota has been saved successfully!',
                            isRotaLoading: false
                        }, function () {
                            self.handleEditHoursModal();
                        });
                    });
                } else {
                    self.setState({
                        isRotaLoading: false,
                        rotaTimeError: response.data.messages
                    });
                }
            });
    }

    removerotaFromStore = () => {
        let self = this;
        let rotaTime;

        if (this?.props?.staffRota?.rota?.length > 0) {
            rotaTime = this?.props?.staffRota?.rota?.map((hairdresser, i) => {
                if (hairdresser.rotaInfo && hairdresser.rotaInfo.rota && hairdresser.rotaInfo.rota.schedule) {
                    let profiles = [];
                    _.map(hairdresser.rotaInfo.rota.schedule[0].profiles, function (obj) {
                        if (obj.day !== self.state.days) {
                            profiles.push({
                                "day": obj.day,
                                "startTime": obj.startTime,
                                "endTime": obj.endTime,
                                "breakTimes": obj.breakTimes,
                                "rotaId": obj.rotaId,
                                "weekNumber": obj.weekNumber
                            });
                        }
                    });
                    hairdresser.rotaInfo.rota.schedule[0].profiles = profiles;
                    return hairdresser;
                } else {
                    return hairdresser;
                }
            });
        }
        self.props.dispatch(hairdresserActions.staffRotaUpdateDelete({ rota: rotaTime }));
    }

    deleteRota() {
        let self = this;
        let hairdresser = this.state.selectedHairdresser;
        const rotaInfo = self.currentHoursRotaInfo();   // active site's rota, or the selected sister site's
        let profiles = [];
        if (rotaInfo.rota && rotaInfo.rota.schedule) {
            _.map(rotaInfo.rota.schedule[0].profiles, function (obj) {
                if (obj.day !== self.state.days) {
                    profiles.push({
                        "day": obj.day,
                        "startTime": obj.startTime,
                        "endTime": obj.endTime,
                        "breakTimes": obj.breakTimes,
                    });
                }
            });
        }
        let params = {};
        params.rotaStartDate = rotaInfo.startDate ? rotaInfo.startDate : moment().startOf('isoweek').format("YYYY-MM-DD");
        params.rota = [];

        let obj = {
            "weekNumber": 1,
            profiles: profiles
        };
        params.rota.push(obj);
        params.hairdresserId = hairdresser._id;

        self.setState({
            isRotaDeleteLoading: true
        });

        // A sister site's hours go through the explicit cross-site plane; the active site keeps the legacy call.
        const saveCall = self.crossSiteHours()
            ? sitesService.saveStaffRota({ ...params, userId: hairdresser._id, salonId: self.state.hoursSalonId })
                .then(() => ({ data: { errorCode: 0 } }), (e) => ({ data: { errorCode: 1, messages: e.message || 'Could not save hours' } }))
            : hairdresserService.saveRota(params);
        saveCall
            .then(function (response) {
                if (response.data.errorCode == 0) {
                    if (!self.crossSiteHours()) self.removerotaFromStore();
                    self.setState({
                        successTimeMessage: 'Rota has been saved successfully!',
                        isRotaDeleteLoading: false
                    }, function () {
                        self.handleEditHoursModal();
                    });
                    self.props.dispatch(hairdresserActions.hairdresserStaffRota({ isGetRota: 1, 'hairdresserId': localStorage.getItem('userId') }));
                } else {
                    self.setState({
                        rotaTimeError: response.data.messages,
                        isRotaDeleteLoading: false,
                    });
                }
            });
    }

    saveStartDateRota() {
        let self = this;
        let hairdresser = this.state.selectedHairdresser;
        let profiles = [];
        if (hairdresser.rotaInfo && hairdresser.rotaInfo.rota && hairdresser.rotaInfo.rota.schedule) {
            _.map(hairdresser.rotaInfo.rota.schedule[0].profiles, function (obj) {
                profiles.push({
                    "day": obj.day,
                    "startTime": obj.startTime,
                    "endTime": obj.endTime,
                    "breakTimes": []
                });
            });
        }

        let params = {};
        params.rotaStartDate = moment(this.state.selectedStartDate).format('YYYY-MM-DD');
        params.rota = [];

        let obj = {
            "weekNumber": 1,
            profiles: profiles
        };
        params.rota.push(obj);
        params.hairdresserId = hairdresser._id;
        hairdresserService.saveRota(params)
            .then(function (response) {
                if (response.data.errorCode == 0) {
                    self.props.dispatch(hairdresserActions.hairdresserStaffRota({ isGetRota: 1, 'hairdresserId': localStorage.getItem('userId') }));
                    self.setState({
                        successDateMessage: 'Rota has been saved successfully!'
                    }, function () {
                        self.handleDatePickerModal();
                    });
                } else {
                    self.setState({
                        rotaDateError: response.data.messages
                    });
                }
            });
    }

    selectStartDate(e) {
        this.setState({
            selectedStartDate: e
        });
    }

    selectStaff(staffId, staff, action = null) {
        // The row already knows the person; hand it to the panel so the
        // header shows at once while the full record loads.
        this.setState({ editStaffId: staffId, editStaffAction: action, editStaffPreview: staff || null });
    }

    handleStaffContextMenu = (e, staff) => {
        e.preventDefault();
        e.stopPropagation();
        const isOwn = staff._id === localStorage.getItem('userId');
        const isOwner = staff.hairdresserInfo?.isSalonOwner === 1;
        this.setState({
            contextMenu: { staffId: staff._id, staff, isOwn, isOwner, x: e.clientX, y: e.clientY }
        });
    }

    handleStaffContextAction = (action) => {
        const { contextMenu } = this.state;
        if (!contextMenu) return;
        if (action === 'view') {
            this.selectStaff(contextMenu.staffId, contextMenu.staff);
        } else if (action === 'delete') {
            this.selectStaff(contextMenu.staffId, contextMenu.staff, 'delete');
        }
    }

    handleRadioChange = (event) => {
        this.setState({
            employmentTypeId: event.target.value,
            activationCode: "",
            applyCoupon: false,
            activatationCodeError: "",
            error: "",
            activatationCodeSuccess: "",
            discount: 0,
        });
    }

    addStaff = () => {
        let self = this;
        let info = {
            activationCode: self.state.activationCode,
            employmentTypeId: self.state.employmentTypeId,
            selfEmpCount: self.state.selfEmpCount,
        };
        self.props.history.push({ pathname: '/staff/add', state: info });
    }

    applyCoupan = () => {
        this.setState({
            activatationCodeError: "",
            error: "",
            activatationCodeSuccess: "",
            totalPayment: siteSetting.stripe.salonMonthlyPrice + siteSetting.stripe.oneSelfEmpPrice,
            totalPaymentBefore: siteSetting.stripe.salonMonthlyPrice + siteSetting.stripe.oneSelfEmpPrice,
        });
        let self = this;
        if (this.state.activationCode.trim() != "") {
            self.props.dispatch(paymentActions.activationCode({ activationCode: self.state.activationCode.trim() }))
                .then(function (response) {
                    if (response.data.statusCode == 0) {
                        if (response.data.error.errorCode === 10) {
                            self.setState({
                                activatationCodeError: 'Activation Code "' + self.state.activationCode + '" does not exist'
                            });
                        } else {
                            self.setState({
                                activatationCodeError: 'Activation Code "' + self.state.activationCode + '" does not exist'
                            });
                        }
                    } else {
                        let discount = self.state.discount, totalPayment = self.state.totalPayment;
                        if (response.data.responseData.result.percent_off) {
                            discount = (response.data.responseData.result.percent_off / 100) * totalPayment;
                            totalPayment = totalPayment - discount;
                        }
                        if (response.data.responseData.result.amount_off) {
                            discount = response.data.responseData.result.amount_off / 100;
                            totalPayment = totalPayment - discount;
                        }
                        self.setState({
                            discount,
                            totalPayment,
                            isApplyedPromocode: true,
                            activatationCodeSuccess: "Activation code applied successfully"
                        });
                    }
                });
        } else {
            self.setState({
                activatationCodeError: "Please enter activation code",
            });
        }
    }

    onChanged = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            activatationCodeError: "",
            error: "",
        });
        if (e.target.name === "activationCode") {
            this.setState({
                isApplyedPromocode: false,
                discount: 0,
                activatationCodeSuccess: "",
                totalPayment: siteSetting.stripe.salonMonthlyPrice + siteSetting.stripe.oneSelfEmpPrice,
                totalPaymentBefore: siteSetting.stripe.salonMonthlyPrice + siteSetting.stripe.oneSelfEmpPrice,
            });
        }
    }

    handleSearchChange = (e) => {
        this.setState({ searchQuery: e.target.value });
    }

    handleFilterChange = (filter) => {
        this.setState({ filterBy: filter });
    }

    toggleFilterDropdown = () => {
        this.setState(prevState => ({ showFilterDropdown: !prevState.showFilterDropdown }));
    }

    toggleViewMode = (mode) => {
        this.setState({ viewMode: mode });
    }

    retryStaffLoad = () => {
        const hairdresserId = localStorage.getItem('userId');
        if (!hairdresserId) return;
        this.props.dispatch(hairdresserActions.hairdresserStaffRota({
            searchKey: '',
            hairdresserId,
            page: 1,
            listType: 1,
            isGetRota: 1
        }));
    }

    getFilteredStaff = () => {
        const { searchQuery, filterBy } = this.state;
        // A staff row whose linked user record has been deleted arrives as null.
        let staff = (this.props.staffRota?.rota || []).filter(Boolean);

        if (searchQuery) {
            staff = staff.filter(s =>
                s.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                s.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                s.hairdresserInfo?.jobTitle?.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }

        if (filterBy !== 'All') {
            staff = staff.filter(s => {
                // Use loose equality (==) to handle both string and number values
                if (filterBy === 'Owner') return s.hairdresserInfo?.isSalonOwner == 1;
                if (filterBy === 'Self Employed') return s.hairdresserInfo?.employmentTypeId == 2 && s.hairdresserInfo?.isSalonOwner != 1;
                if (filterBy === 'Employed') return s.hairdresserInfo?.employmentTypeId == 1 && s.hairdresserInfo?.isSalonOwner != 1;
                return true;
            });
        }

        return staff.filter(s => s?.name !== "Unknown");
    }

    getEmploymentLabel = (staff) => {
        if (staff.hairdresserInfo?.isSalonOwner === 1) return 'Owner';
        if (staff.hairdresserInfo?.isSalonOwner === 2) return 'Manager';
        if (staff.hairdresserInfo?.employmentTypeId === 2) return 'Self-Employed';
        if (staff.hairdresserInfo?.employmentTypeId === 1) return 'Employed';
        return null;
    }

    getCommissionRate = (staff) => {
        if (staff.hairdresserInfo?.employmentTypeId === 2) {
            const rate = staff.hairdresserInfo?.salonCommissionRate;
            if (rate && rate > 0) return rate + '%';
        }
        return null;
    }

    toggleStaffMenu = (staffId, e) => {
        e.stopPropagation();
        this.setState(prevState => ({
            openMenuId: prevState.openMenuId === staffId ? null : staffId
        }));
    }

    handleEditStaff = (staffId, e) => {
        e.stopPropagation();
        this.setState({ openMenuId: null, editStaffId: staffId });
    }

    handleEditStaffClose = (didSave) => {
        this.setState({ editStaffId: null }, () => {
            // Only refresh staff list if changes were saved
            if (didSave) {
                const hairdresserId = localStorage.getItem('userId');
                const params = {
                    searchKey: '',
                    hairdresserId,
                    page: 1,
                    listType: 1,
                    isGetRota: 1
                };
                this.props.dispatch(hairdresserActions.hairdresserStaffRota(params));
            }
        });
    }

    getInitials = (name) => {
        if (!name) return '?';
        const parts = name.trim().split(' ');
        if (parts.length >= 2) {
            return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        }
        return name.substring(0, 2).toUpperCase();
    }

    renderStaffRow = (staff, isLast) => {
        const isMenuOpen = this.state.openMenuId === staff._id;
        const hasImage = staff.userImage?.circleImage;
        const empLabel = this.getEmploymentLabel(staff);
        const commission = this.getCommissionRate(staff);
        const jobTitle = staff.hairdresserInfo?.jobTitle || 'Staff Member';

        // Build subtitle: "Stylist · Self-Employed" or "Manager · Owner"
        const subtitleParts = [jobTitle];
        if (empLabel) subtitleParts.push(empLabel);

        return (
            <div
                key={staff._id}
                className={`staff-row${isLast ? '' : ' staff-row--border'}`}
                onClick={(e) => {
                    if (e.target.closest('.staff-row-action')) return;
                    this.selectStaff(staff._id, staff);
                }}
                onContextMenu={(e) => this.handleStaffContextMenu(e, staff)}
            >
                {hasImage ? (
                    <div className="staff-row-avatar">
                        <img src={staff.userImage.circleImage} alt={staff.name} />
                    </div>
                ) : (
                    <div className="staff-row-avatar staff-row-avatar--initials">
                        {this.getInitials(staff.name)}
                    </div>
                )}
                <div className="staff-row-info">
                    <span className="staff-row-name">{staff.name}</span>
                    <span className="staff-row-sub">{subtitleParts.join(' \u00B7 ')}</span>
                </div>
                {commission && (
                    <span className="staff-row-commission">{commission}</span>
                )}
            </div>
        );
    }

    renderStaffList = () => {
        const filteredStaff = this.getFilteredStaff();

        if (this.props.staffRota?.error) {
            return (
                <div className="staff-list-empty">
                    <p>We couldn't load your team just now.</p>
                    <button type="button" className="staff-retry-btn" onClick={this.retryStaffLoad}>Try again</button>
                </div>
            );
        }

        if (!this.props.staffRota?.rota) {
            return (
                <div className="staff-list-empty">
                    <Lottie options={defaultOptions} height={40} width={160} />
                </div>
            );
        }

        if (filteredStaff.length === 0) {
            return (
                <div className="staff-list-empty">
                    <p>No staff members found</p>
                </div>
            );
        }

        return (
            <div className="staff-list">
                {filteredStaff.map((staff, i) => this.renderStaffRow(staff, i === filteredStaff.length - 1))}
            </div>
        );
    }

    renderStaffTable = () => {
        const filteredStaff = this.getFilteredStaff();

        if (this.props.staffRota?.error) {
            return (
                <tr>
                    <td colSpan={6} className="text-center">
                        <p>We couldn't load your team just now.</p>
                        <button type="button" className="staff-retry-btn" onClick={this.retryStaffLoad}>Try again</button>
                    </td>
                </tr>
            );
        }

        if (!this.props.staffRota?.rota) {
            return (
                <tr>
                    <td colSpan={6} className="text-center">
                        <Lottie options={defaultOptions} height={50} width={200} />
                        <h4>Loading Data...</h4>
                    </td>
                </tr>
            );
        }

        if (filteredStaff.length === 0) {
            return (
                <tr className="pointer-event">
                    <td colSpan={6} className="text-center">
                        No Data Available
                    </td>
                </tr>
            );
        }

        return filteredStaff.map((staff, i) => (
            <tr
                key={staff._id}
                className="pointer-event"
                onClick={() => this.selectStaff(staff._id, staff)}
            >
                <td>
                    <img src={staff.userImage?.circleImage || require('../../assets/images/client-plachoder.jpg')} alt={staff.name} />
                </td>
                <td>{staff.name}</td>
                <td>
                    {staff.hairdresserInfo.isSalonOwner == 1 ? "Owner" : ""}
                    {staff.hairdresserInfo.isSalonOwner == 2 ? "Account Manager" : ""}
                    {staff.hairdresserInfo.isSalonOwner == 0 && staff.hairdresserInfo.employmentTypeId == 1 ? "Employed" : ""}
                    {staff.hairdresserInfo.isSalonOwner == 0 && staff.hairdresserInfo.employmentTypeId == 2 ? "Self-Employed" : ""}
                </td>
                <td className="text-center">
                    {staff.hairdresserInfo.employmentTypeId == 2
                        ? (staff.hairdresserInfo.salonCommissionRate && staff.hairdresserInfo.salonCommissionRate > 0
                            ? staff.hairdresserInfo.salonCommissionRate + "%"
                            : "No")
                        : "N/A"}
                </td>
                <td>{staff.email}</td>
                <td>{staff.hairdresserInfo.jobTitle}</td>
                <td>{staff.phoneNumber && staff.phoneNumber != '' ? "+" + staff.phoneNumber : "--"}</td>
            </tr>
        ));
    }

    handleTabChange = (tab) => {
        this.setState({ activeTab: tab });
    }

    /**
     * Which Team tabs this person may use. Flag off: exactly as before (owner
     * gates Staff Pay; no Permissions tab). Flag on: capabilities. Permissions
     * never shows while Reception Mode is on — a front-desk device must not
     * change who has access.
     */
    teamTabs() {
        const isOwner = this.props.user?.userInfo?.hairdresser?.isSalonOwner === 1;
        let receptionOn = false;
        try { receptionOn = !!JSON.parse(localStorage.getItem('receptionModeSettings') || '{}').enabled; } catch (e) { /* ignore */ }
        return {
            staffMember: true,
            schedules: true,
            staffPay: isOwner || can('team'),
            permissions: PERMISSIONS_VISIBLE && (can('team') || can('permissions')) && !receptionOn,
            // Same people as Settings › Sharing, less self-employed stylists
            // (they keep it in Settings). Never in Reception Mode, like Permissions.
            sharing: (isOwner || can('team') || can('settings')) && !receptionOn,
        };
    }

    render() {
        let { editHoursModal, datePickerModal, searchQuery, filterBy, activeTab } = this.state;
        const isSalonOwner = this.props.user?.userInfo?.hairdresser?.isSalonOwner === 1;
        // A self-employed stylist whose role lets them manage the team gets the
        // team view; otherwise their own profile, as before.
        const isSelfEmployed = this.props.user?.userInfo?.hairdresser?.employmentTypeId === 2 && !isSalonOwner && !can('team');
        const pageTitle = isSelfEmployed ? 'Profile' : 'Staff';
        const selfEmpStaffId = isSelfEmployed ? (this.props.user?.userInfo?.hairdresser?.userId || this.props.user?.userInfo?.userId || this.props.user?.userInfo?.hairdresser?._id) : null;

        return (
            <div className="h_n catalogue-no-header">
                <div className="body_container cm_bg_white">
                    <TopHeader
                        title={pageTitle}
                        headerButtonStatus={false}
                        {...this.props}
                    />
                    <div className="catalogue-page-wrapper staff-page">
                        <StaffTopNav activeTab={activeTab} onTabChange={this.handleTabChange} isSelfEmployed={isSelfEmployed} allowedTabs={this.teamTabs()}>
                            {activeTab === 'staffMember' && (isSalonOwner || can('team')) && (
                                <Dropdown className="catalogue-add-dropdown">
                                    <Dropdown.Toggle id="catalogue-add-staff"><span>Add</span></Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => this.setState({ showAddStaff: true })}>New team member</Dropdown.Item>
                                        {ONBOARDING_ENABLED && canImport() && <Dropdown.Item onClick={() => openOnboardingLayer({ mode: 'import' })}>Import from a file</Dropdown.Item>}
                                    </Dropdown.Menu>
                                </Dropdown>
                            )}
                        </StaffTopNav>
                        <div className="catalogue-content-container">
                            {/* Staff Members View */}
                            {activeTab === 'staffMember' && !isSelfEmployed && (
                                <>
                                    <div className="staff-toolbar">
                                        <div className="staff-search">
                                            <svg className="staff-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
                                            </svg>
                                            <input
                                                type="text"
                                                className="staff-search-input"
                                                value={searchQuery}
                                                onChange={this.handleSearchChange}
                                                placeholder="Search staff..."
                                            />
                                            {searchQuery && (
                                                <button className="staff-search-clear" onClick={() => this.setState({ searchQuery: '' })} type="button">
                                                    <RxCross2 />
                                                </button>
                                            )}
                                        </div>
                                        <div className="staff-filter-group">
                                            {['All', 'Owner', 'Employed', 'Self Employed'].map(f => (
                                                <button
                                                    key={f}
                                                    className={`staff-filter-pill${filterBy === f ? ' staff-filter-pill--on' : ''}`}
                                                    onClick={() => this.handleFilterChange(f)}
                                                >
                                                    {f}
                                                </button>
                                            ))}
                                        </div>
                                        {/* What each self-employed stylist has chosen lives in
                                            Team › Sharing now (Oct 2026), a tab per area. */}
                                        {filterBy === 'Self Employed' && (isSalonOwner || can('team')) && (
                                            <Link className="tc-moved" to="/staff/sharing?tab=marketing">Their choices are in Sharing</Link>
                                        )}
                                    </div>
                                    {this.renderStaffList()}
                                </>
                            )}

                            {/* Self-employed: show profile inline */}
                            {activeTab === 'staffMember' && isSelfEmployed && selfEmpStaffId && (
                                <EditStaff
                                    key={selfEmpStaffId}
                                    {...this.props}
                                    staffId={selfEmpStaffId}
                                    inline={true}
                                    onClose={() => {}}
                                />
                            )}

                            {/* Staff Pay View (owner only, hidden by reception mode) */}
                            {activeTab === 'permissions' && this.teamTabs().permissions && <PermissionsPage />}
                            {activeTab === 'sharing' && this.teamTabs().sharing && <SharingTabs {...this.props} basePath="/staff/sharing" />}
                            {activeTab === 'staffPay' && this.teamTabs().staffPay && !(() => {
                                try {
                                    const r = JSON.parse(localStorage.getItem('receptionModeSettings') || '{}');
                                    return r.enabled && r.hiddenAreas && r.hiddenAreas.staffPay;
                                } catch (e) { return false; }
                            })() && (
                                <StaffPay
                                    staffRota={this.props.staffRota}
                                    dispatch={this.props.dispatch}
                                />
                            )}

                            {/* Schedules & Hours View */}
                            {activeTab === 'schedules' && (() => {
                                const days = [
                                    { key: 'mon', label: 'Mon', full: 'Monday' },
                                    { key: 'tue', label: 'Tue', full: 'Tuesday' },
                                    { key: 'wed', label: 'Wed', full: 'Wednesday' },
                                    { key: 'thu', label: 'Thu', full: 'Thursday' },
                                    { key: 'fri', label: 'Fri', full: 'Friday' },
                                    { key: 'sat', label: 'Sat', full: 'Saturday' },
                                    { key: 'sun', label: 'Sun', full: 'Sunday' },
                                ];
                                const scheduleQuery = this.state.scheduleSearch.toLowerCase();
                                const filteredRota = this?.props?.staffRota?.rota?.filter(staff =>
                                    staff.name !== "Unknown" && (!scheduleQuery || staff.name.toLowerCase().includes(scheduleQuery))
                                ) || [];
                                return (
                                    <>
                                    {!isSelfEmployed && (
                                    <div className="staff-toolbar">
                                        <div className="staff-search">
                                            <svg className="staff-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
                                            </svg>
                                            <input
                                                type="text"
                                                className="staff-search-input"
                                                value={this.state.scheduleSearch}
                                                onChange={(e) => this.setState({ scheduleSearch: e.target.value })}
                                                placeholder="Search staff..."
                                            />
                                            {this.state.scheduleSearch && (
                                                <button className="staff-search-clear" onClick={() => this.setState({ scheduleSearch: '' })} type="button">
                                                    <RxCross2 />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    )}
                                    <div className="schedule-wrap">
                                        <div className="schedule-header">
                                            <div className="schedule-header-name"></div>
                                            {days.map((d, i) => (
                                                <div className="schedule-header-day" key={i}>{d.label}</div>
                                            ))}
                                        </div>
                                        {filteredRota.length > 0 ?
                                            filteredRota.map((staff) => (
                                                <div className="schedule-row" key={staff._id}>
                                                    <div className="schedule-name">{staff.name}</div>
                                                    <div className="schedule-days">
                                                        {days.map(day => (
                                                            <div
                                                                className="schedule-cell"
                                                                key={day.key}
                                                                onClick={this.handleEditHoursModal.bind(this, day.full, staff, day.key)}
                                                            >
                                                                <span className="schedule-cell-label">{day.label}</span>
                                                                {this.getTime(staff.rotaInfo, day.key)}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ))
                                        :
                                            <div className="staff-list-empty"><p>No staff found</p></div>
                                        }
                                    </div>
                                    </>
                                );
                            })()}
                        </div>
                    </div>

                    {/* Edit Hours Sheet */}
                    {editHoursModal && (
                        <SlidePanel
                            title={`Edit ${this.state.selectedHairdresser ? this.state.selectedHairdresser.name : ""}'s Hours`}
                            onClose={this.closeEditHours}
                            footer={
                                <>
                                    <button className="sp-btn-secondary" onClick={this.deleteRota.bind(this)} type="button" style={{ color: '#dc2626' }}>
                                        {this.state.isRotaDeleteLoading ? <MySpinner /> : 'Delete'}
                                    </button>
                                    <button className="sp-btn-primary" onClick={this.saveRota.bind(this)} type="button">
                                        {this.state.isRotaLoading ? <MySpinner /> : 'Save'}
                                    </button>
                                </>
                            }
                            headerRight={<p className="eh-subtitle" style={{ margin: 0, fontSize: '13px', color: '#888' }}>{this.state.selectedDay}</p>}
                        >
                                {this.state.hoursSites && (
                                    <div style={{ marginBottom: 16 }}>
                                        <p style={{ margin: '0 0 8px', fontSize: 12, fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', color: '#8a8a90' }}>Hours at</p>
                                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                            {this.state.hoursSites.map((w) => {
                                                const on = String(w.salonId) === String(this.state.hoursSalonId);
                                                return (
                                                    <button key={String(w.salonId)} type="button" onClick={() => this.selectHoursSite(String(w.salonId))} disabled={this.state.hoursSiteLoading}
                                                        style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '7px 12px', borderRadius: 999, border: `1px solid ${on ? '#1a1a1a' : '#e5e5e5'}`, background: on ? '#1a1a1a' : '#fff', color: on ? '#fff' : '#1a1a1a', fontSize: 13, fontWeight: 500, cursor: 'pointer' }}>
                                                        <span style={{ width: 8, height: 8, borderRadius: 999, background: siteColour(w.salonId), display: 'inline-block' }} />{w.salonName}
                                                    </button>
                                                );
                                            })}
                                        </div>
                                        <p style={{ margin: '8px 0 0', fontSize: 12, color: '#9ca3af' }}>{this.crossSiteHours() ? 'Editing this person\'s hours at another of your locations.' : 'Each location keeps its own hours for this person.'}</p>
                                    </div>
                                )}
                                <div className="eh-time-row">
                                    <div className="eh-time-field">
                                        <label>Start Time</label>
                                        <ShiftTimePicker label="Start Time" selected={this.state.startTime} onChange={this.selectSlot.bind(this, 'startTime')} />
                                    </div>
                                    <div className="eh-time-field">
                                        <label>Finish Time</label>
                                        <ShiftTimePicker label="Finish Time" selected={this.state.endTime} onChange={this.selectSlot.bind(this, 'endTime')} />
                                    </div>
                                </div>
                                {this.state.breakTime.map((breakTime, i) => (
                                    <AddBreak key={"break_" + i} selectSlot={this.selectSlot} i={breakTime.id} startTime={this.state['breakStartTime_' + breakTime.id]} endTime={this.state['breakEndTime_' + breakTime.id]} removeBreak={this.removeBreak} />
                                ))}
                                <button className="eh-add-break" onClick={this.addBreak.bind(this)} type="button">
                                    <Plus /> Add break
                                </button>
                                {this.state.successTimeMessage && (
                                    <p className="eh-message eh-message--success">{this.state.successTimeMessage}</p>
                                )}
                                {this.state.rotaTimeError && (
                                    <p className="eh-message eh-message--error">{this.state.rotaTimeError}</p>
                                )}
                        </SlidePanel>
                    )}

                    {/* Date Picker Modal */}
                    <Modal className="h_n cm_popup cm_hours_popup stff-modal-hour" show={datePickerModal} onHide={this.handleDatePickerModal.bind(this, '')} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>{this.state.selectedHairdresser ? this.state.selectedHairdresser.name : ""}'s Start Date</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="text-center">
                                <DatePicker
                                    inline
                                    filterDate={isWeekday}
                                    selected={this.state.selectedStartDate}
                                    onChange={this.selectStartDate.bind(this)}
                                />
                                <div className="mt-4 mb-4">
                                    <button onClick={this.handleDatePickerModal.bind(this, '')} className="btn btn-outline-dark pl-4 pr-4">Cancel</button>
                                    <button type="button" className="btn btn-dark ml-3 pl-4 pr-4" onClick={this.saveStartDateRota.bind(this)}>Save</button>
                                </div>
                                <br />
                                {this.state.successDateMessage ?
                                    <span className="cm_succ_msg">{this.state.successDateMessage}</span> : ''}
                                {this.state.rotaDateError ?
                                    <span className="cm_error_msg">{this.state.rotaDateError}</span> : ''}
                            </div>
                        </Modal.Body>
                    </Modal>

                    {this.state.editStaffId && (
                        <EditStaff
                            key={this.state.editStaffId + (this.state.editStaffAction || '')}
                            {...this.props}
                            staffId={this.state.editStaffId}
                            initialStaff={this.state.editStaffPreview}
                            initialAction={this.state.editStaffAction}
                            onClose={this.handleEditStaffClose}
                        />
                    )}

                    {this.state.contextMenu && (
                        <ListContextMenu
                            x={this.state.contextMenu.x}
                            y={this.state.contextMenu.y}
                            items={[
                                {
                                    label: 'View Staff',
                                    icon: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="5" r="3" stroke="currentColor" strokeWidth="1.2"/><path d="M2 14c0-3.3 2.7-6 6-6s6 2.7 6 6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/></svg>,
                                    action: 'view'
                                },
                                ...(!this.state.contextMenu.isOwn && !this.state.contextMenu.isOwner && can('team') ? [
                                    { divider: true },
                                    {
                                        label: 'Remove Staff Member',
                                        icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg>,
                                        action: 'delete',
                                        danger: true
                                    }
                                ] : [])
                            ]}
                            onAction={this.handleStaffContextAction}
                            onClose={() => this.setState({ contextMenu: null })}
                        />
                    )}

                    {this.state.showAddStaff && (
                        <AddStaff
                            {...this.props}
                            onClose={(didAdd) => {
                                this.setState({ showAddStaff: false }, () => {
                                    if (didAdd) {
                                        const hairdresserId = localStorage.getItem('userId');
                                        const params = {
                                            searchKey: '',
                                            hairdresserId,
                                            page: 1,
                                            listType: 1,
                                            isGetRota: 1
                                        };
                                        this.props.dispatch(hairdresserActions.hairdresserStaffRota(params));
                                    }
                                });
                            }}
                        />
                    )}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ...state
    };
}

export default connect(mapStateToProps)(Staff);
